import React from 'react';
import PropTypes from 'prop-types';

import './rotatedImage.scss';

/**
 * Component that renders an image that can be rotated a given number of degrees using a prop.
 * @extends {PureComponent}
 */
class RotatedImage extends React.PureComponent {
  render() {
    const wrapperStyle = {
      backgroundColor: this.props.fillColor,
    };
    const imageStyle = {
      transform: `rotate(${this.props.rotationAmount}deg)`,
    };

    if (this.props.sizeBoundries) {
      const { height, width } = this.props.sizeBoundries;
      wrapperStyle.height = height;
      wrapperStyle.width = width;
    }

    return (
      <div className='wtfRotatedImage'>
        <div
          className='wtfRotatedImage_wrapper'
          style={wrapperStyle}
        >
          <img
            className='wtfRotatedImage_image'
            src={this.props.imageUrl}
            alt='Rotated'
            style={imageStyle}
          />
        </div>
      </div>
    );
  }
}

/**
 * @type {Object}
 * @property {Object|Null}  sizeBoundries
 * @property {String}       fillColor
 */
RotatedImage.defaultProps = {
  sizeBoundries: null,
  fillColor: 'transparent',
};

/**
 * @type {Object}
 * @property {String} imageUrl        URL for the image that's going to be rotated.
 * @property {Number} rotationAmount  Number of degrees the image is rotated. Positive numbers
 *                                    mean clockwise rotation. Negative is counterclockwise.
 * @property {String} fillColor       Color to fill the empty spaces left after the rotation.
 *                                    Defaults to `transparent`.
 * @property {Object} sizeBoundries   Object containing the target width and height used as
 *                                    boundries for the rotation. If the image is being rotated
 *                                    and goes past those values, overflow will be hidden.
 *                                    Defaults to `null`.
 */
RotatedImage.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  rotationAmount: PropTypes.number.isRequired,
  fillColor: PropTypes.string,
  sizeBoundries: PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
  }),
};

export default RotatedImage;



// WEBPACK FOOTER //
// ./src/components/Crop/RotatedImage/RotatedImage.js